
import { COLORS } from "@/utils/theme/colors"
import { Avatar } from "@mui/material"
import { ReactNode, Ref, forwardRef } from "react"
import { GenerateNick } from "../../utils/functions/CommonFunction"
import { TAvatarProps } from "@/utils/types/CustomAvatar"

const CustomAvatar = ({ name, url, width, height, color, bgColor, fontSize, radius, unknown, ...props }: TAvatarProps, ref: Ref<any>): ReactNode => {
  name = url ? "" : name
  let initials = url ? "" : GenerateNick(name)

  return ( // @ts-ignore
    <Avatar
      ref={ref}
      alt={name}
      src={url}
      sx={{
        width: width ?? 40,
        height: height ?? 40,
        color: color ? color : unknown ? COLORS?.black : COLORS?.adminAppTextSecondary,
        background: bgColor ? bgColor : unknown ? COLORS?.lightGrey : COLORS?.adminAppOutlineColor,
        fontSize: fontSize,
        borderRadius: radius
      }}
      {...props}
    >
      {initials.toUpperCase()}
    </Avatar>
  )
}

export default forwardRef(CustomAvatar)
